'use strict';

module.exports = root;

/* Stringify a root.
 * Adds a final newline to ensure valid POSIX files. */
function root(node) {
  return this.block(node) + '\n';
}



//////////////////
// WEBPACK FOOTER
// ./~/remark/~/remark-stringify/lib/visitors/root.js
// module id = 302
// module chunks = 147254134005266 182246549230831 215303740077764